/**
 * Chakra `<Container>` keeps default horizontal padding unless these props are applied
 * after `useMultiStyleConfig('contentful/container')` styles.
 * @param {string|null} mode - output of `normalizeContainerFullWidth`
 */
export function getContainerFullWidthChakraProps(mode) {
  if (mode === 'Yes') {
    return {maxW: '100%', w: '100%', px: 0};
  }
  if (mode === 'Yes, Mobile Only') {
    return {
      maxW: {base: '100%', lg: 'container.xxxl'},
      mx: {base: undefined, lg: 'auto'},
      px: {base: 0, lg: 8},
    };
  }
  return {};
}

/** BEM modifier on `component--container` for Contentful `fullWidth` dropdown. */
const FULL_WIDTH_CLASS_BY_MODE = {
  No: 'component--container--full-width-no',
  Yes: 'component--container--full-width-yes',
  'Yes, Desktop Only': 'component--container--full-width-yes-desktop-only',
  'Yes, Mobile Only': 'component--container--full-width-yes-mobile-only',
};

/**
 * @param {string|null} mode - output of `normalizeContainerFullWidth`
 * @returns {string|undefined}
 */
export function getContainerFullWidthClassName(mode) {
  return mode ? FULL_WIDTH_CLASS_BY_MODE[mode] : undefined;
}
